import { render, staticRenderFns } from "./DynamicFields.vue?vue&type=template&id=385cddc6&scoped=true&"
import script from "./DynamicFields.vue?vue&type=script&lang=js&"
export * from "./DynamicFields.vue?vue&type=script&lang=js&"
import style0 from "./DynamicFields.vue?vue&type=style&index=0&id=385cddc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385cddc6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VContainer,VIcon})
